/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import buildIndividuUpdatePayload from './buildIndividuUpdatePayload';

/**
 * Construit le payload de mise à jour d'un onglet « PARENT » du panel des
 * personnes de la fiche acte, envoyé via `service.update`
 * (PUT `/numerisation-actes/naissance/{identifiant}`).
 *
 * La modal est la même pour le parent 1 et le parent 2 : seul `numeroParent`
 * change, et avec lui la clé du sous-objet (`parent1` / `parent2`).
 *
 * @param identifiant Identifiant de l'**acte** : c'est lui qui construit l'URL du PUT.
 */
const buildParentUpdatePayload = (
  identifiant: number,
  numeroParent: 1 | 2,
  parent: Record<string, any> | undefined,
  data: Record<string, any>,
): Record<string, any> => ({
  identifiant,
  [`parent${numeroParent}`]: buildIndividuUpdatePayload(parent, data),
});

export default buildParentUpdatePayload;
